// Navigation configuration for different user types
export const USER_TYPES = {
  STAFF: 'staff',
  PATIENT: 'patient',
  PRACTICE: 'practice',
  PRACTICE_ADMIN: 'practice administrator'
};

export const NAVIGATION_CONFIG = {
  [USER_TYPES.STAFF]: [
    { name: 'Appointments', path: '/appointments' }
  ],
  [USER_TYPES.PATIENT]: [
    { name: 'Make an Appointment', path: '/welcome' },
    { name: 'Appointments', path: '/appointments' }
  ],
  [USER_TYPES.PRACTICE]: [
    { name: 'User Management', path: '/viewUsers' },
    { name: 'Service Locations', path: '/viewServices' },
    { name: 'Appointments', path: '/appointments' }
  ],
  [USER_TYPES.PRACTICE_ADMIN]: [
    { name: 'User Management', path: '/viewUsers' },
    { name: 'Service Locations', path: '/viewServices' },
    { name: 'Appointments', path: '/appointments' }
  ]
};

export const HEADER_STYLES = {
  CONTAINER: 'w-full h-[70px] bg-white flex items-center px-4 sm:px-6',
  LOGO: 'h-[50px] w-[80px] bg-cover bg-center',
  NAV_TAB: 'px-4 py-2 text-sm font-medium relative transition-colors h-full flex items-center',
  NAV_TAB_ACTIVE: 'text-gray-800 bg-white border-b-2 border-[#0B6D76]',
  NAV_TAB_INACTIVE: 'text-gray-600 hover:text-gray-800 hover:bg-gray-50',
  NAV_BORDER: 'border-b-2 border-transparent',
  ACTIVE_BORDER: 'absolute bottom-0 left-0 right-0 h-0.5 bg-[#0B6D76]',
  USER_AVATAR: 'w-8 h-8 bg-[#0B6D76] rounded-full flex items-center justify-center',
  USER_NAME: 'text-sm font-medium text-gray-900',
  USER_TYPE: 'text-xs text-gray-500 capitalize',
  DROPDOWN_BUTTON: 'flex items-center space-x-2 p-2 rounded-lg hover:bg-gray-100 transition-colors',
  DROPDOWN_MENU: 'absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50',
  DROPDOWN_ITEM: 'w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors'
};
